import { render, staticRenderFns } from "./PhoneCard.vue?vue&type=template&id=07c993c8&scoped=true&"
import script from "./PhoneCard.vue?vue&type=script&lang=js&"
export * from "./PhoneCard.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCard.vue?vue&type=style&index=0&id=07c993c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c993c8",
  null
  
)

export default component.exports